<header class="ao-header">
	<div class="ao-header-brand">
		<a href="https://www.auto-owners.com/" target="_self">
			<img [src]="aoLogoSrc" class="ao-logo" alt="Auto-Owners" crossorigin="anonymous" />
		</a>
	</div>
</header>
